import type { IVoteOptimizationStrategy, VoteAllocation, VoteOptimizationInput } from "../vote-optimization-strategy"
import { calculateBeastDistribution } from "../vote-optimization"
import { STRATEGY_ICON } from "../vote-optimization-strategy-factory"

/**
 * Beast strategy: Maximally concentrates votes for highest theoretical returns
 * Warning: Extreme risk of vote dilution
 */
export class BeastVoteOptimizationStrategy implements IVoteOptimizationStrategy {
  calculateDistribution(input: VoteOptimizationInput): Array<VoteAllocation> | null {
    const distribution = calculateBeastDistribution(input.gaugeBribes, input.selectedVotePower, true)
    return distribution
  }

  getName(): string {
    return "Beast"
  }

  getDescription(): string {
    return "Maximally concentrates votes for highest theoretical returns. Warning: Extreme risk of vote dilution."
  }

  getIcon() {
    return STRATEGY_ICON.SWORD
  }
}
